import swal from 'sweetalert';
import template from './listView.html';
import ListController from '../../list.controller.js';

class ListViewController extends ListController {
    constructor($uibModal, DS, $q, logger) {
        super();
        this.$uibModal = $uibModal;
        this.$q = $q;
        this.logger = logger;
        this.view = this.view || false;
        this.Model = this.store || false;
        this.datastore = () => DS;

        this.icon = this.view.icon();
        this.pageTitle = this.view.title();
        this.pageDesc = this.view.description();

        this.getState();
    }

    getState() {
        this.resolveReferences().then(() => {
            this.getItems();
        });
    }

    resolveReferences() {
        let models = [];
        let datastore = this.datastore();

        _.forOwn(this.view.getReferences(), (value, key) => {
            models.push(datastore.definitions[value.targetEntity().name()]);
        });

        return this.$q.all(models.map(m => m.findAll()));
    }

    getQueryset(params) {
        return this.Model.findAll(params, { bypassCache: true });
    }

    edit(item) {
        const model = item;
        const entity = this.view.entity;
        const view = entity.editionView();
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                }
            }
        });

        modal.result.then(model => {
            this.Model.update(model.id, model)
                .then(() => this.getState())
                .catch(error => {
                    this.logger.error('Upsss', error.data);
                });
        });
    }

    canInsert() {
        const fields = this.view.entity.editionView().fields();
        return fields.length > 0;
    }

    insert() {
        const model = {};
        const entity = this.view.entity;
        const view = entity.editionView();
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                }
            }
        });

        modal.result.then(model => {
            this.Model.create(model)
                .then(() => {
                    this.Model.ejectAll();
                    this.getState();
                })
                .catch(error => {
                    this.logger.error('Upsss', error.data);
                });
        });
    }

    delete(item) {
        const previousWindowKeyDown = window.onkeydown;
        swal(
            {
                title: `Brisanje retka entiteta ${this.view.title()}`,
                text: `Za potvrdu brisanja upišite 'da'`,
                type: 'input',
                showCancelButton: true,
                closeOnConfirm: false
            },
            inputValue => {
                window.onkeydown = previousWindowKeyDown;
                if (inputValue === false) return false;
                if (inputValue === 'da') {
                    this.Model.destroy(item.id).then(
                        data => {
                            this.getState();
                            swal('Redak obrisan', '', 'success');
                        },
                        error => {
                            swal('Greška', `Došlo je do greške prilikom brisanja`, 'error');
                        }
                    );
                    return true;
                }
                swal.showInputError('Nedozvoljena vrijednost');
                return false;
            }
        );
    }

    btnClicked(btnId, params) {}
}

ListViewController.$inject = ['$uibModal', 'DS', '$q', 'logger'];

const ListViewComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: ListViewController,
    controllerAs: 'vm',
    bindings: {
        view: '<',
        store: '<'
    }
};

export { ListViewComponent };



// WEBPACK FOOTER //
// ./app/components/common/crud/list/listView.component.js